import React, { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

const ConfigContext = createContext({});

export function ConfigProvider({ children }) {
  const [config, setConfig] = useState({
    google_client_id: process.env.REACT_APP_GOOGLE_CLIENT_ID || "",
    whatsapp_number: process.env.REACT_APP_WHATSAPP_NUMBER || "34613807514",
    contact_email: "info@pillauncoche.com",
    maintenance_mode: false,
    id_verification_enabled: false,
    phone_verification_enabled: false,
    rental_min_hours: 10,
    precio_km_extra: 0.175,
    precio_combustible_litro: 2.5,
  });

  useEffect(() => {
    axios.get("/api/config").then(r => setConfig(c => ({ ...c, ...r.data }))).catch(() => { });
  }, []);

  return <ConfigContext.Provider value={config}>{children}</ConfigContext.Provider>;
}

export const useConfig = () => useContext(ConfigContext);
